import React, { useState, useRef, useEffect } from 'react'
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { _FETCH, _FETCH_POST, _CREATE, _UPDATE } from '../utils/patches';
import BlueButton from '../components/BlueButton';
import Loading from '../whitaijiFrontendLibrary/components/Loading'
import {ConcertMusicPlayer} from '../components/ConcertMusicPlayer';
import T, { dT } from '../components/Translation';
import { IoIosInformationCircleOutline } from "react-icons/io";
import { GiStarsStack } from "react-icons/gi";
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import useMediaQuery from '../hooks/useMediaQuery';
import {PicturesMash} from '../components/MakeConcert'
import ScrollDiv from '../components/ScrollDiv';
import { blueColour, goldColour, lighterBlueColour } from './Home';
import { CiSaveDown1 } from "react-icons/ci";
import { useMutation } from '@tanstack/react-query';
import MindFeedbackMatrix from '../components/MindFeedbackMatrix'
import { generateMongoDBId } from '../whitaijiFrontendLibrary/lib/utils';
import { runFireworks } from '../components/Fireworks';
import Journal from '../components/Journal';




const Concert = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const {hideTestButtons, apiUrl, language, } = useStateContext()
    const concertId = urlParams.get('_id');
    const {user} = useAuthContext(AuthContext)

    const queryClient = useQueryClient() 

     const navigate = useNavigate()

     useEffect(() => {
      if (!concertId) {
        navigate('/')
      }
    }, [concertId])

    const { data: concert,  isLoading: isLoadingConcert } = useQuery({
      queryKey: ['concert', concertId],
      enabled: !!concertId && !!apiUrl,
      queryFn: async () => {
          const concerts = await _FETCH({
            route: `${apiUrl}/concerts/${concertId}`,
            user
          });
          return concerts;
        }
    });
    const { data: logConcertInProgress, isLoading: isLoadingLogConcertInProgress } = useQuery({
      queryKey: ['logConcertInProgress'],
      enabled: !!concertId && !!apiUrl,
      queryFn: async () => {
          const concerts = await _FETCH({
            route: `${apiUrl}/concert-logs/in-progress/${concertId}`,
            user
          });
          return concerts;
        }
    });



    const [viewInfo, setViewInfo] = useState(false);
    const [tabIndex, setTabIndex] = useState(logConcertInProgress?._id ? 3 : 0);
   
    const [concertLogId, setConcertLogId] = useState(logConcertInProgress?._id ? logConcertInProgress?._id : generateMongoDBId())
    const [startFeedback, setStartFeedback] = useState(logConcertInProgress?.startFeedback);
    const [endFeedback, setEndFeedback] = useState(null);
    const [journalEntryId, setJournalEntryId] = useState(logConcertInProgress?.journalEntryId);
    const [currentSongId, setCurrentSongId] = useState(logConcertInProgress?.currentSongId);
    const [completedOn, setCompletedOn] = useState(null);
    const [songLogs, setSongLogs] = useState(!Array.isArray(logConcertInProgress?.songLogs) ? [] : logConcertInProgress?.songLogs); 


    useEffect(() => {
      if (logConcertInProgress) {
        setConcertLogId(logConcertInProgress?._id);
        setStartFeedback(logConcertInProgress?.startFeedback);
        setCurrentSongId(logConcertInProgress?.currentSongId);
        setCompletedOn(logConcertInProgress?.completedOn);
        //const exampleSongLogs = !Array.isArray(songs) ? [] : songs?.map?.((song) => ({songId: song._id, loggedOn: new Date()}))
        //setSongLogs(exampleSongLogs);
        setSongLogs(!Array.isArray(logConcertInProgress?.songLogs) ? [] : logConcertInProgress?.songLogs);
       if(!logConcertInProgress?.completedOn){
        setTabIndex(3);}
        }
        if(logConcertInProgress?.completedOn){
        setTabIndex(6);}
        
        
    }, [logConcertInProgress]);

    useEffect(() => {
      if (tabIndex == 6) {
        runFireworks();
      }
    }, [tabIndex]);

    const concertLog = {
      _id: concertLogId,
      concertId,
      concertTitle: concert?.title,
      status: "inProgress",
      startFeedback,
      endFeedback,
      journalEntryId,
      currentSongId,
      completedOn,
      songLogs
    }

  
  const onError = (error) => {
    process.env.NODE_ENV === "development" && console.error('Error logging song:', error);
  };
  
  const onSuccess = (data) => {
    process.env.NODE_ENV === "development" && console.log('Concert logged successfully:', data);
  };
    //const [currentConcert, setCurrentConcert] = useState(emptyCurrentConcert);
  const { mutate: logConcert } = useMutation({
    mutationFn: async(doc) => {
      process.env.NODE_ENV === "development" && console.log('logConcert Calling :', doc);
      return await _CREATE({
        route: `${apiUrl}/concert-logs`, 
        doc: doc, 
        user, 
        onSuccess, 
        onError
      });
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['logConcertInProgress'] }),
    mutationKey: ['logConcertInProgress'],
  });
    const { mutate: updateLogConcert } = useMutation({
    mutationFn: async(doc) => {
      process.env.NODE_ENV === "development" && console.log('Calling _UPDATE with doc:', doc);
      return await _UPDATE({
        route: `${apiUrl}/concert-logs/${doc._id}`, 
        doc: doc, 
        user, 
        onSuccess, 
        onError
      });
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['logConcertInProgress'] }),
    mutationKey: ['logConcertInProgress'],
  });
    const { mutate: softUpdateLogConcert } = useMutation({
    mutationFn: async(doc) => {
      process.env.NODE_ENV === "development" && console.log('Soft Update Calling:', doc);
      return await _UPDATE({
        route: `${apiUrl}/concert-logs/${doc._id}`, 
        doc: doc, 
        user, 
        onSuccess, 
        onError
      });
    },
    //onSettled: () => queryClient.invalidateQueries({ queryKey: ['logConcertInProgress'] }),
    //mutationKey: ['logConcertInProgress'],
      });
    const containsAllSongs = (songIdArray, otherArray) => {
      const songIdSet = new Set(songIdArray?.map(obj => obj?.songId));
      return otherArray?.every(obj => songIdSet?.has(obj?._id));
    }
    const startConcert = (e) => {
      e?.preventDefault();
      setTabIndex(1);
      //concertRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    const next = () => {
      setTabIndex(tabIndex + 1);
    }
    const saveFirstFeedback = (data) => {
      setStartFeedback(Number(data))
      logConcert({...concertLog, startFeedback: Number(data)})
      next()
      //concertRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    const saveSecondFeedback = (data) => {
      
      setEndFeedback(Number(data))
      next()
      //concertRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    const completeConcert = (journalEntry) => {
      const now = new Date();
      setCompletedOn(now)
      updateLogConcert({_id:concertLogId, journalEntryId: journalEntry?._id, status: "completed", completedOn: now, endFeedback})
      next()
    }
    const saveSongLog = (data) => {
      const newSongLog = {
        _id: data?._id,
        songId: data?.songId,
        loggedOn: new Date()
      }
      setCurrentSongId(data?.songId)
      setSongLogs([...songLogs, newSongLog])
      const newConcertLog = {
        ...concertLog,
        currentSongId: data?.songId,
        songLogs: [...songLogs, newSongLog]
      }
      
      softUpdateLogConcert(newConcertLog)
      //next()
      //concertRef.current?.scrollIntoView({ behavior: 'smooth' });
      hideTestButtons && console.log('saveSongLog', {data, newSongLog, newConcertLog}) 
    }
    const songIdsToLoad = !Array.isArray(concert?.songs) ? [] : concert?.songs?.map((song) => song?.songTemplateId);

    const { data: songs, isLoading: isLoadingSongs } = useQuery({
        queryKey: ['songs', songIdsToLoad],
        enabled: !!songIdsToLoad.length && !!apiUrl,
        queryFn: async () => {
            const songs = await _FETCH_POST({
                route: `${apiUrl}/concerts/songs/byIds`,
                body: { songIds: songIdsToLoad },
                user
            });
            return songs;
        }
    });

    const songsToPlayer = !Array.isArray(songs) ? [] : songs
      ?.map((song) => {
        const songInConcert = !Array.isArray(concert?.songs) ? undefined : concert?.songs?.find((item) => item?.songTemplateId == song?._id)
        return {
          ...song, 
          order: songInConcert?.order,
          lyricsToHighlight: songInConcert?.lyrics?.filter((lyric) => lyric?.status !== "archived"),  
          affirmation: songInConcert?.affirmation,
          status: songInConcert?.status,
          isWithPrelude: song?.isWithPrelude,
          imageUrl: `https://remind-public.s3.eu-north-1.amazonaws.com/images/${song?.imageName}.png`,
          songInConcertId: songInConcert?._id,
          aiVoSource: `https://remind-public.s3.eu-north-1.amazonaws.com/aivo/${songInConcert?._id}.mp3`,
          
        }
        })
      ?.filter((song) => song?.status !== "archived")
      ?.sort((a, b) => a?.order - b?.order)
    const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("dihqdhwed myConcert", {concert, tabIndex, logConcertInProgress, songsToPlayer, songs, concertLog})
    }
    const screenChange = 1020
    const screenSizeNotMobile = useMediaQuery(`(min-width: ${screenChange}px)`)
    const mobileStyle = screenSizeNotMobile ? {} : {
      flexDirection: "column"
    }
    if(isLoadingConcert || isLoadingSongs || isLoadingLogConcertInProgress) return <Loading/> 

  return (
    <div className="home">
      <BlueButton hide={hideTestButtons} fn={testFunction}/>
      <div style={{marginLeft:"10px", display:"flex", alignItems:"center"}}>
        <BlueButton home />
        <BlueButton color={lighterBlueColour} text={""} fn={() => setViewInfo(!viewInfo)}>
          <div  style={{display:"flex", alignItems:"center"}}>
              <IoIosInformationCircleOutline size={25}/>  
              <div style={{marginLeft:"5px"}}>
                <T obj={{
                  it: "Informazioni Concerto",
                  en: "Concert Info"}}  
                />
              </div>
            
          </div>
        </BlueButton>
      </div>
     
      <div style={{display:"flex", justifyContent:"center", textAlign:"center", color:goldColour, margin:"20px"}}>
        <h1>{concert?.title}</h1>
      </div>
       {/* 
      <VisDiv rules={[tabIndex == 0 || viewInfo]}>
        <div style={{display:"flex", marginTop:"10px", textAlign:"center", justifyContent:"center", margin:"20px"}}>
          <span>
            <strong>{concert?.description}</strong>
          </span>
        </div>
        <div style={{display:"flex", justifyContent:"center"}}>
          <PicturesMash style={{maxWidth:"550px"}} picSrcs={songs?.map((x) => `https://remind-public.s3.eu-north-1.amazonaws.com/images/${x?.imageName}.png`)}/>
        </div>
      </VisDiv>
      <VisDiv rules={[viewInfo]} style={{padding:"10px"}}>
        <div style={{display:"flex", flexDirection:"column", textAlign:"left", padding:"10px"}}> 
          <div style={{display:"flex", color:goldColour, justifyContent:"left"}}>
            <h3>
              <T obj={{en: "How I Feel", it: "Come Mi Sento"}}/>
            </h3>
          </div>
          <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
            <p>
              {concert?.aiQuestion}
            </p>
          </div>
          <div style={{display:"flex", color:goldColour, marginTop:"20px", justifyContent:"left"}}>
            <h3>
              <T obj={{en: "Ai Response", it: "Risposta Ai"}}/>
            </h3>
          </div>
          <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
            <p>
              {concert?.aiAnswer}
            </p>
          </div>
          <div style={{display:"flex", color:goldColour, marginTop:"20px", justifyContent:"left", marginBottom:"10px"}}>
            <h3>
              <T obj={{en: "Songs And Lyrics To Focus On", it: "Canzoni E Parole Su Cui Porre Attenzione"}}/>
            </h3>
          </div>
          <ScrollDiv>
            {songsToPlayer?.map((song, index) => {
              return(
              <div key={index} className="scroll-item" style={{
                display: "flex", 
                width: "370px",
                minWidth: "370px",
                padding: "15px", 
                borderRadius: "10px", 
                border: "1px solid #ccc", 
                margin: "10px",
                flexDirection: "column",
                background: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}>
                <div style={{marginBottom: "10px", marginTop: "10px", display: "flex", justifyContent: "center"}}>
                  <h4>
                  {song?.title}
                  </h4>
                </div>
                <div style={{marginBottom: "10px", display: "flex", justifyContent: "center",}}>
                  <img src={song?.imageUrl} style={{width: "100%", borderRadius: "10px"}} alt="song-image" />
                </div>
                <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
                  <h4><T obj={{en: "Affirmation", it: "Affermazione"}}/></h4>
                </div>
                {song?.affirmation}
                <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
                  <h4><T obj={{en: "Lyrics", it: "Testi"}}/></h4>
                </div>
                {song?.lyricsToHighlight?.map((lyric, index) => {
                  return(
                    <div key={index} >
                      <LyricPin data={{lyric, concert}}/>
                    </div>
                  )
                })}
              </div>
                )
            })}  
          </ScrollDiv> 
        </div>
      </VisDiv> */}
      <ConcertInfo tabIndex={tabIndex} concert={concert} viewInfo={viewInfo} songsToPlayer={songsToPlayer}/>
      <VisDiv style={{display:"flex", justifyContent:"center"}} rules={[tabIndex == 0]}>
        <BlueButton style={{marginLeft:"10px", display:"flex", alignItems:"center"}} fn={startConcert} text="">
          <div style={{display:"flex", alignItems:"center"}}>
            <div style={{marginRight:"10px"}}>
              <T obj={{
                it: "Inizia Concerto",
                en: "Start Concert"}}  
              />
            </div>
          </div>
        </BlueButton>
      </VisDiv>
      <VisDiv style={{padding:"15px", textAlign: "center"}} rules={[tabIndex == 1]}>
        <div style={{marginBottom:"10px"}}>
          <h2><T obj={{
            en: `Take a moment to read your concert prompt, close your eyes and focus on how you feel right now.
            When you are ready, click next`, 
            it: `Prendi un momento per leggere la tua domanda di concerto, chiudi gli occhi e fai attenzione a come sentiti ora. Quando sei pronto, clicca avanti`}} />
          </h2>
        </div>
        <div style={{backgroundColor:goldColour, margin:"10px", padding:"30px", borderRadius:"10px"}}>
          <h3>{concert?.aiQuestion}</h3>
        </div>
        
      </VisDiv>
      <VisDiv rules={[tabIndex == 2]}>
          <MindFeedbackMatrix
            title={dT({en: "How are you feeling right now? 0 being the worst, 10 being the best. Pick the first number you see or that comes to mind", it: "Come ti senti adesso? 1 molto male, 10 molto bene. Scegli il primo numero che vedi o che ti viene in mente"}, language)}
            saveFeedback={saveFirstFeedback}
          />
      </VisDiv>
      <VisDiv rules={[tabIndex == 3]}  style={{margin: "10px"}}>
        <ConcertMusicPlayer 
          hideTestButtons={hideTestButtons} 
          containerStyle={{maxWidth:"100%"}} 
          songs={songsToPlayer} 
          songLogCallback={saveSongLog}
          logPercentage={0.75}
          songsCompleted = {songLogs}
        />
      </VisDiv>
      
      <VisDiv rules={[tabIndex == 4]}>  
        <MindFeedbackMatrix
            title={dT({en: `At the beginning of this concert you felt ${startFeedback} out of 10. How are you feeling now?`, it: `All'inizio di questo concerto ti sentivi ${startFeedback} su 10. Come ti senti ora?`}, language)}
            saveFeedback={saveSecondFeedback}

        />
      </VisDiv>
      <VisDiv rules={[tabIndex == 5]}>
        <Journal
          songs={songsToPlayer} 
          concertLogId = {concertLogId}
          concertTitle = {concert?.title}
          onSubmit = {completeConcert} 
          submitOnSave = {true}
          justNewEntry = {true} 
        />
        <div style={{display:"flex", justifyContent:"center", marginBottom:"10px"}}> 
          <BlueButton color='red' fn={completeConcert} text="">
            <T obj={{
              it: "Salta",
              en: "Skip"}}  
            />
          </BlueButton>
        </div>

      </VisDiv>
      <VisDiv style={{textAlign:"center"}} rules={[tabIndex == 6]}>
        <h1 style={{color:"green"}}> <T obj={{en: "CONGRATULATIONS! CONCERT COMPLETED", it: " CONGRATULAZIONI! CONCERTO COMPLETATO"}}/></h1>
        <BlueButton home />
      </VisDiv>
      <VisDiv style={{display:"flex", justifyContent:"center"}} rules={[tabIndex !== 0, tabIndex < 5]}>
        <BlueButton hide={tabIndex == 3 && !containsAllSongs(songLogs, songsToPlayer)} buttonStyle={{fontSize:"18px", padding:"18px"}} style={{display:"flex", fontSize:"20px", padding:"15px", alignItems:"center"}} color='green' fn={next} text="">
              <T obj={{
                it: "Successivo",
                en: "Next"}}  
              />
        </BlueButton>
      </VisDiv>
    </div>
  )
}

export default Concert

export const LyricPin = ({data}) => {

  const {lyric, concert } = data 
  const [showInfo, setShowInfo] = useState(false)
  const onInfoClick = (e) => {
      e.stopPropagation()
      setShowInfo(!showInfo)
  }
  const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
  const concertSongLyrics = concert?.lyrics
  const lyricInConcertSong = !Array.isArray(concertSongLyrics) ? undefined : concertSongLyrics.find((l) => l?.lyricTemplateId == lyric?._id)
  const isLyricInConcertSong = !Array.isArray(concertSongLyrics) ? false : concertSongLyrics.some((l) => l?.lyricTemplateId == lyric?._id)
  const isLyricArchived = !Array.isArray(concertSongLyrics) ? false : concertSongLyrics.some((l) => l?.lyricTemplateId == lyric?._id && l?.status == "archived")

  return (
      <>
      <div style={{margin:"10px", display:"flex", alignItems:"center", padding:"3px",}}>      
          <div>
              {lyric.text}
          </div>
          <VisDiv onClick={onInfoClick} style={{marginLeft:"10px", cursor:"pointer"}} rules={[lyric?.aiDescription]}>
              <IoIosInformationCircleOutline size={25}/>
          </VisDiv>
      </div>
      <VisDiv style={{border:"1px dotted #ccc", marginLeft:"30px", padding:"10px", color:"gray", marginBottom:"10px"}} rules={[showInfo]}>
          <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
              <div style={{marginRight:"10px"}}>
               <GiStarsStack size={18}/>
              </div>
              <div style={{fontWeight:"bold"}}>
                  <T obj={{en:"reMind ai says:", it: "reMind ia spiega:"}}/>
              </div>
              
          </div>
          <p>{lyric?.aiDescription}</p>
      </VisDiv>
      </>
  )
}

export const ConcertInfo = ({concert, viewInfo, songsToPlayer, tabIndex}) => {
 return (
    <>
      <VisDiv rules={[tabIndex == 0 || viewInfo]}>
        <div style={{display:"flex", marginTop:"10px", textAlign:"center", justifyContent:"center", margin:"20px"}}>
          <span>
            <strong>{concert?.description}</strong>
          </span>
        </div>
        <div style={{display:"flex", justifyContent:"center"}}>
          <PicturesMash style={{maxWidth:"550px"}} picSrcs={songsToPlayer?.map((x) => `https://remind-public.s3.eu-north-1.amazonaws.com/images/${x?.imageName}.png`)}/>
        </div>
      </VisDiv>
        <VisDiv rules={[viewInfo]} style={{padding:"10px"}}>
        <div style={{display:"flex", flexDirection:"column", textAlign:"left", padding:"10px"}}> 
          <div style={{display:"flex", color:goldColour, justifyContent:"left"}}>
            <h3>
              <T obj={{en: "How I Feel", it: "Come Mi Sento"}}/>
            </h3>
          </div>
          <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
            <p>
              {concert?.aiQuestion}
            </p>
          </div>
          <div style={{display:"flex", color:goldColour, marginTop:"20px", justifyContent:"left"}}>
            <h3>
              <T obj={{en: "Ai Response", it: "Risposta Ai"}}/>
            </h3>
          </div>
          <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
            <p>
              {concert?.aiAnswer}
            </p>
          </div>
          <div style={{display:"flex", color:goldColour, marginTop:"20px", justifyContent:"left", marginBottom:"10px"}}>
            <h3>
              <T obj={{en: "Songs And Lyrics To Focus On", it: "Canzoni E Parole Su Cui Porre Attenzione"}}/>
            </h3>
          </div>
          <ScrollDiv>
            {songsToPlayer?.map((song, index) => {
              return(
              <div key={index} className="scroll-item" style={{
                display: "flex", 
                width: "370px",
                minWidth: "370px",
                padding: "15px", 
                borderRadius: "10px", 
                border: "1px solid #ccc", 
                margin: "10px",
                flexDirection: "column",
                background: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}>
                <div style={{marginBottom: "10px", marginTop: "10px", display: "flex", justifyContent: "center"}}>
                  <h4>
                  {song?.title}
                  </h4>
                </div>
                <div style={{marginBottom: "10px", display: "flex", justifyContent: "center",}}>
                  <img src={song?.imageUrl} style={{width: "100%", borderRadius: "10px"}} alt="song-image" />
                </div>
                <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
                  <h4><T obj={{en: "Affirmation", it: "Affermazione"}}/></h4>
                </div>
                {song?.affirmation}
                <div style={{display:"flex", marginTop:"10px", justifyContent:"left"}}>
                  <h4><T obj={{en: "Lyrics", it: "Testi"}}/></h4>
                </div>
                {song?.lyricsToHighlight?.map((lyric, index) => {
                  return(
                    <div key={index} >
                      <LyricPin data={{lyric, concert}}/>
                    </div>
                  )
                })}
              </div>
                )
            })}  
          </ScrollDiv> 
        </div>
      </VisDiv>
    </>
  ) 
}